import { GatsbyImage } from 'gatsby-plugin-image'
import { getLuminance } from 'polished'
import React from 'react'
import styled from 'styled-components'
import getGatsbyImage from 'utils/getGatsbyImage'
import RichTextRenderer from '../../UI/RichTextRenderer'
import StrapiButton from '../StrapiButton'

const Wrapper = styled.div`
  padding: 20px;
  .cta-strip-bg {
    > :first-child {
      position: absolute !important;
      height: 100%;
      width: 100%;
      left: 0;
      bottom: 0;
      z-index: -1;
    }
    margin-bottom: 0 !important;
  }


`

const Content = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  > * { margin-bottom: 14px; }
  > :last-child { margin-bottom: 0; }
  
  > .cta--content {
    > :first-child {
      min-height: initial;
      margin: 0;
      padding: 0;
    }
  }
`


const Title = styled.h3`
  font-family: 'Rammetto One';
`

const CTAStrip = (props: Strapi.CTAStrip) => {
  const isDark = getLuminance(props.bgColor || '#FFF') < 0.5
  const color = isDark ? '#FFF' : '#000'

  return <Wrapper style={{ backgroundColor: props.bgColor, color }}>
    { props.bgImage && <div className='cta-strip-bg'>
      <GatsbyImage image={getGatsbyImage(props.bgImage.localFile)} alt={props.bgImage.alternativeText} />  
    </div>}
    <Content>
      { props.title && <Title>{props.title}</Title>}
      { props.button && <StrapiButton {...props.button} />}
      { props.content && <div className='cta--content'><RichTextRenderer>{props.content}</RichTextRenderer></div>}
    </Content>
  </Wrapper>
}

export default CTAStrip
